import { render, staticRenderFns } from "./EditDepartmentComponent.vue?vue&type=template&id=b4641658&"
import script from "./EditDepartmentComponent.vue?vue&type=script&lang=js&"
export * from "./EditDepartmentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports